import { useTranslation } from "next-i18next";

export function VisitSlug({ visitLength }: { visitLength: number }) {
  const { t } = useTranslation();
  return <span className="custom-visit-slug">{t("visit_length_slug", { length: visitLength })}</span>;
}
